import CaseDispatch from './CaseDispatch.vue';

export default CaseDispatch;
